import { c as _c } from "react/compiler-runtime";
const TableNoRows = t0 => {
  const $ = _c(5);
  const {
    title,
    button
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="mt-6 max-w-sm text-center">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== button || $[3] !== t1) {
    t2 = <tr><td className="p-4 text-lg text-primary" colSpan={1000}><div className="flex flex-col items-center gap-6">{t1}{button}</div></td></tr>;
    $[2] = button;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default TableNoRows;